import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { concatMap, map, switchMap, toArray } from 'rxjs/operators';
import { AntDataResponse } from '@antony/ng-ui';
import { AntCollectionSortLoadingParams, ResourceCollectionApiService } from '@api/models';
import { ContactPersonDto, CustomerContactPersonsApiService } from '@api/api.service';
import { LoadingParamsUtils } from '@api/utils';

@Injectable({
  providedIn: 'root',
})
export class CustomerContactPersonService implements ResourceCollectionApiService<ContactPersonDto> {
  constructor(private api: CustomerContactPersonsApiService) {}

  getData(params: AntCollectionSortLoadingParams<ContactPersonDto>): Observable<AntDataResponse<ContactPersonDto>> {
    return this.api
      .getPagedContactPersons(
        LoadingParamsUtils.getIdFrom(params),
        LoadingParamsUtils.getSkipFrom(params),
        LoadingParamsUtils.getTakeFrom(params),
        LoadingParamsUtils.getFilterNamesFrom(params),
        LoadingParamsUtils.getFilterValueFrom(params),
        LoadingParamsUtils.getSortNamesFrom(params),
        LoadingParamsUtils.getApiSortDirection(params)
      )
      .pipe(
        map((res) => ({
          data: res.data || [],
          maxCount: res.maxCount || 0,
        }))
      );
  }

  add(customerId: number, contactPersonId: number): Observable<boolean> {
    return this.api.createContactPerson(customerId, contactPersonId).pipe(map((res) => res.success));
  }

  addBulk(customerId: number, contactPersonIds: number[]): Observable<boolean[]> {
    return from(contactPersonIds).pipe(
      concatMap((contactPersonId) => this.add(customerId, contactPersonId)),
      toArray()
    );
  }

  remove(customerId: number, contactPersonId: number): Observable<boolean> {
    return this.api.deleteContactPerson(customerId, contactPersonId).pipe(map((res) => res.success));
  }

  removeBulk(customerId: number, contactPersonIds: number[]): Observable<boolean[]> {
    return this.api.deleteBulkContactPersons(customerId, contactPersonIds).pipe(
      map((res) => res.data || []),
      switchMap((responses) => from(responses)),
      map((res) => res.success),
      toArray()
    );
  }
}
